<script setup>
import usePublicStore from "@/store/public";
import { storeToRefs } from "pinia";

const {
  leyendaPaso,
  mostrarPasoDatos,
  mostrarPasoDatosEmpresa,
  mostrarPasoDatosActivo,
  mostrarPasoCotFinalizada,
} = storeToRefs(usePublicStore());
</script>

<template>
  <section>
    <div v-if="!mostrarPasoCotFinalizada">
      <div class="d-flex flex-row align-items-center px-4 py-4 bg-warning">
        <div class="col-md-10 mx-auto">
          <h2 class="mb-0 text-dark py-3">{{ leyendaPaso }}</h2>
        </div>
      </div>
      <div class="col-md-10 mx-auto">
        <div
          class="p-4 bg-light"
          style="
            border-bottom-left-radius: 30px;
            border-bottom-right-radius: 30px;
          "
        >
          <h5 class="text-center text-dark fw-light">
            Ingresa tu correo electrónico, que será nuestro medio de contacto
            principal. Luego, te pedimos que verifiques tu<br />número de
            celular para garantizar que tus datos estén correctos y que tu
            cotización te llegue directamente a ti.
          </h5>
        </div>

        <div class="col-md-9 mx-auto">
          <div class="my-3">
            <div
              class="or d-flex flex-row justify-content-center align-items-center border text-center rounded-pill text-dark"
            >
              <div
                class="col-md-3 py-2 rounded-pill"
                :class="mostrarPasoDatos ? 'bg-warning' : ''"
              >
                <span class="fw-bold">Datos generales</span>
              </div>
              <div
                class="col-md-6 py-2 rounded-pill"
                :class="mostrarPasoDatosEmpresa ? 'bg-warning' : ''"
              >
                <span class="fw-bold">Datos personales y de la empresa</span>
              </div>
              <div
                class="col-md-3 py-2 rounded-pill"
                :class="mostrarPasoDatosActivo ? 'bg-warning' : ''"
              >
                <span class="fw-bold">Información de activo</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
